import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/programs_az/:_channel?/:_search_query?',
      name: 'programs_az',
      props: true,
      component: () => import('./components/ProgramsAZ.vue')
    },
    {
      path: '/:type?/:_channel?/:_current_day?/:exact_match?/:genre_list?/:_episode_id?',
      name: 'schedule',
      props: true,
      component: () => import('./components/PBS12Schedule.vue')
    },

  ]
})
